import { fuseauValide } from './flux-cron.js';

/**
 * LE FUSEAU DE L'ORGANISATION : un nom IANA, regle par l'owner dans
 * Parametres > Environnement (`orgs/{orgId}/settings/environnement`, champ
 * `fuseau`). Absent ou illisible : Europe/Luxembourg, le comportement d'avant
 * le reglage. Inventaire des calculs qui le lisent : `docs/socle/fuseau-org.md`.
 */
export const FUSEAU_PAR_DEFAUT = 'Europe/Luxembourg';

/** Le fuseau d'une valeur brute du reglage : un nom IANA connu, sinon le defaut. */
export function fuseauDe(brut: unknown): string {
  return typeof brut === 'string' && brut.length > 0 && brut.length <= 64 && fuseauValide(brut) ? brut : FUSEAU_PAR_DEFAUT;
}

/** Jour civil d'un instant, dans le fuseau de l'organisation. */

export function jourDansFuseau(maintenant: Date, timezone = FUSEAU_PAR_DEFAUT): string {
  const parts = new Intl.DateTimeFormat('fr-CA', {
    timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(maintenant);
  const lire = (type: string) => parts.find(part => part.type === type)?.value;
  return `${lire('year')}-${lire('month')}-${lire('day')}`;
}

export function estDatePure(value: unknown): value is string {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const date = new Date(`${value}T12:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
}
